var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section1 slider" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "swiper",
            rawName: "v-swiper:mySwiper",
            value: _vm.swiperOption,
            expression: "swiperOption",
            arg: "mySwiper",
          },
        ],
        ref: "mySwiper",
        on: { slideChangeTransitionEnd: _vm.slideChange },
      },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.match_data, function (match) {
            return _c("div", { key: match.id, staticClass: "swiper-slide" }, [
              _c("div", { staticClass: "match-details" }, [
                _c("div", { staticClass: "match-name" }, [
                  _c("span", { staticClass: "match-category" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(match.event_name) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "teams" }, [
                    _c("span", { staticClass: "team1" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getTeamSN("t1", match)) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "versus" }, [
                      _vm._v(_vm._s(_vm.translations.vs_label)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "team2" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getTeamSN("t2", match)) +
                          "\n              "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "match-time" }, [
                  _c("span", { staticClass: "match-category" }, [
                    _vm._v(_vm._s(match.upcoming_in.custom_date)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "teams" }, [
                    _c("span", { staticClass: "versus" }, [
                      _vm._v(_vm._s(match.upcoming_in.custom_time)),
                    ]),
                  ]),
                ]),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("a", {
          staticClass: "slider-nav swiper-button-prev",
          attrs: { slot: "button-prev", href: _vm.matchByIndexOffset(-1) },
          slot: "button-prev",
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "slider-nav swiper-button-next",
          attrs: { slot: "button-next", href: _vm.matchByIndexOffset(1) },
          slot: "button-next",
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }